// Scroll to the top of the current page
function scrollToTop() {
  return window.scrollTo(0, 0)
}

export default scrollToTop
